import React from 'react';
import { Link } from 'react-router-dom';
import './RelatedLinks.css';

interface RelatedLinksProps {
  currentPage: string;
}

const RelatedLinks: React.FC<RelatedLinksProps> = ({ currentPage }) => {
  const links = [
    { path: '/', title: '首页', description: '德国展会翻译与现场协助服务' },
    { path: '/about', title: '关于我们', description: '专业德国留学生展会服务团队' },
    { path: '/contact', title: '联系我们', description: '获取德国展会服务咨询与报价' },
  ];

  // 过滤掉当前页面
  const filteredLinks = links.filter(link => link.path !== currentPage);

  return (
    <div className="related-links">
      <h3>相关链接</h3>
      <div className="related-links-container">
        {filteredLinks.map((link, index) => (
          <Link to={link.path} key={index} className="related-link-item">
            <h4>{link.title}</h4>
            <p>{link.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedLinks;